if (!customElements.get('euro25-buying')) {
  customElements.define('euro25-buying', class extends HTMLElement {
    connectedCallback() {
      Promise.all(['variant-radios', 'product-info', 'product-form'].map(name => customElements.whenDefined(name))).then(() => this.init());
    }
    init() {
      if (this.ready || !this.isConnected || this.dataset.product !== '9342305239293') return;
      this.root = this.closest('product-info');
      this.native = this.root?.querySelector('variant-radios');
      this.quantity = this.root?.querySelector('.quantity__input');
      this.form = this.root?.querySelector('product-form form');
      this.submit = this.form?.querySelector('[name="add"]');
      this.variants = JSON.parse(this.querySelector('[data-euro25-variants]').textContent);
      this.labels = JSON.parse(this.querySelector('[data-euro25-labels]').textContent);
      this.metre = this.variants.find(v => /^per met(?:er|re)$/i.test(v.title.trim()));
      this.rolls = this.variants.filter(v => /^roll of\s+([\d.]+)met$/i.test(v.title.trim()));
      if (!this.native || !this.quantity || !this.form || !this.submit || !this.metre || this.rolls.length !== this.variants.length - 1 || this.native.querySelectorAll('fieldset').length !== 1) return;
      this.ready = true;
      this.money = cents => new Intl.NumberFormat(this.dataset.locale || 'en-ZA', {style:'currency',currency:this.dataset.currency || 'ZAR',currencyDisplay:'narrowSymbol',minimumFractionDigits:2}).format(cents / 100);
      this.length = v => Number(v.title.match(/^roll of\s+([\d.]+)met$/i)?.[1] || 0);
      this.formatInputs = [...this.querySelectorAll('input[type="radio"]')];
      this.rollSelect = this.querySelector('select');
      this.rollField = this.querySelector('.euro25-roll-field');
      this.status = this.querySelector('.euro25-status');
      this.unitPrice = this.querySelector('.euro25-unit-price');
      this.quantities = {metre:Math.max(this.metre.min || 1, Number(this.quantity.value) || 1),roll:1};
      this.refreshOptions();
      this.detail = document.createElement('p');
      this.detail.className = 'euro25-quantity-detail';
      this.detail.setAttribute('aria-live','polite');
      this.root.querySelector('.product-form__quantity').append(this.detail);
      const guideSection = [...document.querySelectorAll('.shopify-section')].find(section => /How much fabric do I need\?/i.test(section.querySelector('h1,h2,h3')?.textContent || ''));
      if (guideSection) {
        const guide = document.createElement('div');
        guide.className = 'euro25-guide';
        const link = document.createElement('a');
        link.href = '#' + guideSection.id;
        link.textContent = this.labels.guide;
        const small = document.createElement('small');
        small.textContent = this.labels.guideDetail;
        guide.append(link,small);
        this.root.querySelector('.product-form__quantity').after(guide);
      }
      this.total = document.createElement('div');
      this.total.className = 'euro25-total';
      this.total.setAttribute('role','status');
      this.total.setAttribute('aria-live','polite');
      this.form.querySelector('.product-form__buttons').prepend(this.total);
      this.form.closest('product-form').classList.add('euro25-native-form');
      this.retry = document.createElement('button');
      this.retry.type = 'button';
      this.retry.className = 'button button--secondary euro25-retry';
      this.retry.textContent = this.labels.retry;
      this.retry.hidden = true;
      this.retry.addEventListener('click', () => this.select(this.current.id));
      this.status.after(this.retry);
      this.originalRenderProductInfo = this.native.renderProductInfo;
      this.native.renderProductInfo = () => this.loadSelection();
      this.root.cartUpdateUnsubscriber?.();
      this.root.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        this.desiredQuantity = Number(this.quantity.value) || 1;
        this.loadSelection();
      });
      this.originalUpdateUrl = this.native.updateURL;
      this.native.updateURL = () => {
        if (!this.native.currentVariant || this.native.dataset.updateUrl === 'false') return;
        const url = new URL(window.location.href);
        url.searchParams.set('variant',this.native.currentVariant.id);
        window.history.replaceState(window.history.state,'',url);
      };
      this.addEventListener('change',event => {
        event.stopPropagation();
        if (event.target === this.rollSelect) this.select(Number(this.rollSelect.value));
        else if (this.formatInputs.includes(event.target)) {
          const v = event.target.value === 'metre' ? this.metre : this.rolls.find(v => v.id === this.lastRoll && v.available) || this.rolls.find(v => v.available) || this.rolls[0];
          if (v) this.select(v.id);
        }
      });
      this.quantity.addEventListener('input',() => this.quantityChanged());
      this.quantity.addEventListener('change',() => this.quantityChanged());
      this.form.addEventListener('submit',event => {
        const id = Number(this.form.querySelector('[name="id"]').value);
        if (this.pending || this.failed || id !== this.current.id || !this.current.available || !this.validQuantity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.status.textContent = this.pending ? this.labels.updating : this.current.available ? this.labels.quantityError : this.labels.soldOut;
          this.quantity.reportValidity();
        }
      },true);
      this.variantUnsubscribe = subscribe(PUB_SUB_EVENTS.variantChange,event => {
        if (event.data.sectionId !== this.dataset.section || Number(event.data.variant.id) !== this.current?.id) return;
        const fresh = event.data.html.querySelector('euro25-buying [data-euro25-variants]');
        if (fresh) {
          this.variants = JSON.parse(fresh.textContent);
          this.metre = this.variants.find(v => v.id === this.metre.id);
          this.rolls = this.rolls.map(v => this.variants.find(f => f.id === v.id) || v);
          this.current = this.variants.find(v => v.id === this.current.id);
          this.refreshOptions();
        }
        this.pending = false;
        this.failed = false;
        this.quantity.value = this.desiredQuantity;
        this.render(true);
      });
      this.quantityUnsubscribe = subscribe(PUB_SUB_EVENTS.quantityUpdate,() => {
        if (!this.pending) this.render(false);
      });
      this.onPopState = () => {
        const id = Number(new URL(window.location.href).searchParams.get('variant'));
        const v = this.variants.find(v => v.id === id) || this.metre;
        if (v.id !== this.current?.id) this.select(v.id);
      };
      window.addEventListener('popstate',this.onPopState);
      this.onPageShow = () => this.render(false);
      window.addEventListener('pageshow',this.onPageShow);
      this.observer = new IntersectionObserver(entries => {
        this.root.classList.toggle('euro25-in-view',entries[0].isIntersecting);
      });
      this.observer.observe(this.root);
      this.current = this.variants.find(v => v.id === Number(this.form.querySelector('[name="id"]').value)) || this.metre;
      this.hidden = false;
      this.root.classList.add('euro25-enhanced');
      this.render(true);
    }
    refreshOptions() {
      this.rollSelect.replaceChildren(...this.rolls.map(v => {
        const option = document.createElement('option');
        option.value = v.id;
        option.textContent = `${this.length(v).toFixed(2)} m · ${this.money(v.price)}${v.available ? '' : ' · ' + this.labels.soldOut}`;
        option.disabled = !v.available;
        return option;
      }));
      this.formatInputs.find(input => input.value === 'metre').disabled = !this.metre.available;
      this.formatInputs.find(input => input.value === 'roll').disabled = !this.rolls.some(v => v.available);
    }
    select(id) {
      const next = this.variants.find(v => v.id === id);
      if (!next || (next.id === this.current?.id && !this.failed)) return;
      const radio = [...this.native.querySelectorAll('input[type="radio"]')].find(input => input.value === next.title);
      if (!radio) return;
      if (this.current && this.validQuantity()) this.quantities[this.current.id === this.metre.id ? 'metre' : 'roll'] = Number(this.quantity.value);
      this.current = next;
      const mode = next.id === this.metre.id ? 'metre' : 'roll';
      if (mode === 'roll') this.lastRoll = next.id;
      this.desiredQuantity = this.quantities[mode] || next.min || 1;
      this.pending = true;
      this.failed = false;
      this.quantity.value = this.desiredQuantity;
      this.render(true);
      radio.checked = true;
      radio.dispatchEvent(new Event('change',{bubbles:true}));
    }
    async loadSelection() {
      this.requestController?.abort();
      const controller = new AbortController();
      this.requestController = controller;
      const generation = this.requestGeneration = (this.requestGeneration || 0) + 1;
      const id = this.current.id;
      this.pending = true;
      this.failed = false;
      this.desiredQuantity = this.desiredQuantity || Number(this.quantity.value) || 1;
      this.render(false);
      const timer = setTimeout(() => controller.abort(), 12000);
      try {
        const url = new URL(this.native.dataset.url, window.location.origin);
        url.searchParams.set('variant', id);
        url.searchParams.set('section_id', this.dataset.section);
        const view = new URL(window.location.href).searchParams.get('view');
        if (view) url.searchParams.set('view', view);
        const response = await fetch(url, {signal: controller.signal});
        if (response.ok === false) throw new Error('Selection unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (generation !== this.requestGeneration || id !== this.current.id || !this.isConnected) return;
        const variants = html.querySelector('euro25-buying [data-euro25-variants]');
        if (!variants || !JSON.parse(variants.textContent).some(v => v.id === id)) throw new Error('Selection incomplete');
        for (const prefix of ['price', 'Sku', 'Inventory']) {
          const destination = document.getElementById(`${prefix}-${this.dataset.section}`);
          const source = html.getElementById(`${prefix}-${this.dataset.section}`);
          if (destination && source) {
            destination.innerHTML = source.innerHTML;
            destination.classList.toggle('visibility-hidden', source.classList.contains('visibility-hidden'));
          }
        }
        const add = html.getElementById(`ProductSubmitButton-${this.dataset.section}`);
        this.native.toggleAddButton(add ? add.hasAttribute('disabled') : true, window.variantStrings.soldOut);
        publish(PUB_SUB_EVENTS.variantChange, {data: {sectionId: this.dataset.section, html, variant: {...this.native.currentVariant, id}}});
      } catch (error) {
        if (generation !== this.requestGeneration || !this.isConnected) return;
        this.pending = false;
        this.failed = true;
        this.render(false);
      } finally {
        clearTimeout(timer);
      }
    }
    bounds() {
      const v = this.current;
      const inCart = this.quantity.dataset.cartQuantity == null ? v.cartQuantity || 0 : Number(this.quantity.dataset.cartQuantity) || 0;
      const candidates = [v.max == null ? Infinity : v.max - inCart];
      if (v.managed && v.policy === 'deny') candidates.push(v.inventory - inCart);
      return {min:Number(this.quantity.dataset.min) || v.min || 1,step:v.step || 1,max:Math.max(0,Math.min(...candidates))};
    }
    validQuantity() {
      if (!this.current) return false;
      const q = Number(this.quantity.value), {min,step,max} = this.bounds();
      return Number.isFinite(q) && Number.isInteger(q) && q >= min && q <= max && (q - min) % step === 0;
    }
    quantityChanged() {
      if (!this.current) return;
      if (this.validQuantity()) {
        this.quantities[this.current.id === this.metre.id ? 'metre' : 'roll'] = Number(this.quantity.value);
        if (this.pending) this.desiredQuantity = Number(this.quantity.value);
      }
      this.render(false);
    }
    render(clamp) {
      if (!this.current) return;
      const v = this.current, roll = v.id !== this.metre.id, {min,step,max} = this.bounds();
      this.quantity.min = min;
      this.quantity.step = step;
      if (Number.isFinite(max)) this.quantity.max = max; else this.quantity.removeAttribute('max');
      if (clamp) {
        const requested = Number(this.quantity.value) || min;
        this.quantity.value = Math.max(min,Math.min(requested,Number.isFinite(max) && max >= min ? max : requested));
      }
      const q = Number(this.quantity.value), valid = this.validQuantity();
      for (const input of this.formatInputs) input.checked = input.value === (roll ? 'roll' : 'metre');
      this.rollField.hidden = !roll;
      if (roll) this.rollSelect.value = v.id;
      const label = this.root.querySelector('.quantity__label');
      if (label) {
        const text = [...label.childNodes].find(node => node.nodeType === Node.TEXT_NODE);
        if (text) text.textContent = (roll ? this.labels.quantityRolls : this.labels.quantityMetres) + ' ';
      }
      const price = document.createElement('strong');
      price.textContent = this.money(roll ? Math.round(v.price / this.length(v)) : v.price);
      const unit = document.createElement('small');unit.textContent = ' ' + this.labels.perMetre;
      const detail = document.createElement('span');detail.className = 'euro25-price-detail';
      detail.textContent = roll ? `${this.length(v).toFixed(2)} m ${this.labels.roll} · ${this.money(v.price)} ${this.labels.perRoll}` : '';
      if (!roll && v.compare > v.price) {const strike = document.createElement('s');strike.textContent = `${this.money(v.compare)} ${this.labels.perMetre}`;detail.append(strike);}
      this.unitPrice.replaceChildren(price,unit,detail);
      this.detail.textContent = valid ? roll ? `${(this.length(v) * q).toFixed(2)} ${this.labels.fabricTotal}` : `${q} m × ${this.money(v.price)}` : this.labels.quantityError;
      const totalAmount = document.createElement('strong');totalAmount.textContent = valid ? this.money(v.price * q) : '—';
      const summary = document.createElement('small');summary.textContent = valid ? `${q} ${roll ? q === 1 ? this.labels.roll : this.labels.rolls : q === 1 ? this.labels.metre : this.labels.metres}` : this.labels.quantityError;
      this.total.replaceChildren(document.createTextNode(this.labels.total),totalAmount,summary);
      this.submit.disabled = this.pending || this.failed || !v.available || !valid;
      this.retry.hidden = !this.failed;
      this.status.textContent = this.pending ? this.labels.updating : this.failed ? this.labels.selectionError : !v.available ? this.labels.soldOut : !valid ? this.labels.quantityError : '';
      this.quantity.setCustomValidity(valid ? '' : this.labels.quantityError + (Number.isFinite(max) ? ` (${this.labels.stockLimit} ${max})` : ''));
    }
    disconnectedCallback() {
      this.requestController?.abort();
      if (this.native && this.originalRenderProductInfo) this.native.renderProductInfo = this.originalRenderProductInfo;
      this.variantUnsubscribe?.();this.quantityUnsubscribe?.();this.observer?.disconnect();
      window.removeEventListener('popstate',this.onPopState);window.removeEventListener('pageshow',this.onPageShow);
      if (this.native && this.originalUpdateUrl) this.native.updateURL = this.originalUpdateUrl;
    }
  });
}
